module.exports = __webpack_public_path__ + "static/media/card-logo-4.d4806393.svg";